export const agricolaReportsSettings = {
    id: 0,
    created_at: null,
    title_required: false,
    number_required: false,
    observation_required: false,
    area_required: false,
    video_required: false,
    image_required: false,
    audio_required: false,
    incidence_description_required: false,
    incidence_risk_required: false,
    incidence_amount_required: false,
  };